(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section__firework-embed"] && !Shopify.designMode) return;
  try {
    
/* This function is required for the floating player and floating button.
Shopify's page-builder places these DOM nodes in a weird way that blocks
the static positioning from working properly. Moving the node to be a
direct child of <body> makes it work properly. */

var element = document.getElementById('move-to-body');
if (element) {
  document.querySelector('body').appendChild(element);
}

  } catch(e) { console.error(e); }
})();
})();
